import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import './App.css';
import { NavProgressProvider } from "./components/NavProgressContext";
import { AuthProvider } from "./auth/AuthContext";

function App() {
  return (
    <BrowserRouter>
      <NavProgressProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </NavProgressProvider>
    </BrowserRouter>
  );
}

export default App;
